import { createFormContext } from "@mantine/form"


import type { Event } from "event/types/event.model"

export const [EventFormProvider, useEventFormContext, useEventForm] =
  createFormContext<Omit<Event, "id">>()


